<div class="progress-spinner-V2">
  <svg focusable="false" aria-hidden="true" viewBox="0 0 50 50">
    <circle cx="50%" cy="50%" r="20"></circle>
  </svg>
</div>
